var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimePlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.542,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2385 19.446L21.2384 13.8847C21.2385 13.5393 20.9584 13.2592 20.6131 13.2594C20.2675 13.2594 19.9878 13.5391 19.9878 13.8846L19.9879 19.446L14.4264 19.446C14.0809 19.446 13.8011 19.7258 13.8011 20.0713C13.801 20.4167 14.0811 20.6967 14.4264 20.6966L19.9879 20.6966L19.9879 26.2581C19.9878 26.6034 20.2678 26.8835 20.6132 26.8834C20.7858 26.8832 20.9422 26.8132 21.0553 26.7001C21.1683 26.5871 21.2383 26.4307 21.2383 26.2579L21.2384 20.6965L26.7997 20.6966C26.9725 20.6966 27.1289 20.6266 27.2419 20.5135C27.355 20.4004 27.425 20.244 27.425 20.0713C27.4251 19.7259 27.145 19.4458 26.7997 19.446L21.2385 19.446Z",
    fill: "#343643",
    stroke: "#343643",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimePlus);
export default __webpack_public_path__ + "static/media/TimePlus.4e87402ce5d1aa3f4e17cfb518c924f5.svg";
export { ForwardRef as ReactComponent };